import { queryOptions, useQuery, useSuspenseQuery } from '@tanstack/react-query'
import {
  getMarketPricePerformanceOptions,
  getPricePerformanceOptions,
  getProjectPriceChartOptions,
  getProjectPriceChartSnapshotOptions,
} from './price.options'
import type {
  UserGetPricePerformanceParams,
  UserGetProjectPriceChartParams,
  UserGetProjectPriceChartSnapshotParams,
} from '../api'

export const useMarketPricePerformance = () => {
  return useQuery(queryOptions(getMarketPricePerformanceOptions()))
}

export const usePrefetchMarketPricePerformance = () => {
  return useSuspenseQuery(queryOptions(getMarketPricePerformanceOptions()))
}

export const usePricePerformance = (params: UserGetPricePerformanceParams) => {
  return useQuery(queryOptions(getPricePerformanceOptions(params)))
}

export const useProjectPriceChart = (
  params: UserGetProjectPriceChartParams,
) => {
  return useQuery(queryOptions(getProjectPriceChartOptions(params)))
}
export const useProjectPriceChartSnapshot = (
  params: UserGetProjectPriceChartSnapshotParams,
) => {
  return useQuery(queryOptions(getProjectPriceChartSnapshotOptions(params)))
}
